import { render } from "./Return.vue?vue&type=template&id=300ac220&scoped=true"
import script from "./Return.vue?vue&type=script&lang=js"
export * from "./Return.vue?vue&type=script&lang=js"

import "./Return.vue?vue&type=style&index=0&id=300ac220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300ac220"]])

export default __exports__